<template>
  <Modal
    ref="modal"
    title="Update CR Number"
  >
    <BaseForm
      submit-title="Update"
      @submit="update"
      @cancel="cancel"
    >
      <BaseInput
        v-model="cr_number"
        title="CR Number"
        name="cr_number"
        type="text"
        trim
      />
      <FieldError v-model="error" />
    </BaseForm>
  </Modal>
</template>

<script>
/**
 * a Modal component that creates a new AIM.
 * 'create-cm' event with aim is emitted when created.
 */
import FieldError from '@/components/FieldError'
import Modal from '@/components/Modal'
import aimAPI from '@/api/aim'

export default {
  components: {
    FieldError,
    Modal,
  },
  data () {
    return {
      verId: '',
      ruleId: '',
      cr_number: '',
      error: '',
    }
  },
  methods: {
    reset () {
      this.verId = ''
      this.ruleId = ''
      this.cr_number = ''
      this.error = ''
    },
    cancel () {
      this.$refs.modal.hide()
      this.reset()
    },
    /**
     * @description open modal
     */
    show (verId, ruleId, crNumber) {
      this.reset()
      this.verId = verId
      this.ruleId = ruleId
      this.cr_number = crNumber
      this.$refs.modal.show()
    },
    update () {
      const cr = this.cr_number === '' ? null : this.cr_number
      aimAPI.updateRuleCR(this.verId, this.ruleId, cr).then(resp => {
        this.cancel()
        this.$emit('updatecr', resp)
      }).catch(error => {
        this.error = error.message
      })
    },
  },
}
</script>
